module.exports = __webpack_public_path__ + "img/bgleft.cd35a23b.png";